function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlert = function SvgAlert(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 511.999 511.999"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M501.449 368.914 320.566 66.207C306.751 43.384 282.728 29.569 256 29.569s-50.752 13.815-64.567 36.638L10.55 368.914c-13.812 23.725-14.113 51.954-.599 75.678s37.836 37.838 65.165 37.838h361.766c27.329 0 51.653-14.115 65.165-37.838 13.516-23.724 13.215-51.953-.598-75.678",
    style: {
      fill: "#e50027"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.049 444.592c-13.513 23.723-37.836 37.838-65.165 37.838H256V29.57c26.727 0 50.752 13.815 64.567 36.638L501.45 368.915c13.812 23.724 14.113 51.953.599 75.677",
    style: {
      fill: "#c1001f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.109 452.4c-16.628 0-30.851-8.27-39.063-22.669-8.211-14.414-8.065-31.087.469-45.72L217.23 81.549c8.27-13.666 22.816-21.951 38.769-21.951s30.5 8.284 38.887 22.157l180.745 302.49c8.388 14.4 8.534 31.072.322 45.485-8.211 14.4-22.435 22.669-39.063 22.669z",
    style: {
      fill: "#fd003a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.891 452.4c16.628 0 30.851-8.27 39.063-22.669 8.211-14.414 8.065-31.087-.322-45.485L294.886 81.754c-8.388-13.871-22.933-22.157-38.887-22.157V452.4z",
    style: {
      fill: "#e50027"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.03 152.095v120.122c0 16.517-13.514 30.03-30.03 30.03s-30.031-13.514-30.031-30.03V152.095c0-16.517 13.514-30.031 30.031-30.031s30.03 13.514 30.03 30.031",
    style: {
      fill: "#e1e4fb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.03 152.095v120.122c0 16.517-13.514 30.03-30.03 30.03V122.064c16.516 0 30.03 13.514 30.03 30.031",
    style: {
      fill: "#c5c9f7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 332.278c-24.926 0-45.046 20.119-45.046 45.046 0 24.924 20.119 45.046 45.046 45.046s45.046-20.121 45.046-45.046-20.121-45.046-45.046-45.046",
    style: {
      fill: "#e1e4fb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.046 377.323c0 24.924-20.119 45.046-45.046 45.046v-90.091c24.925 0 45.046 20.12 45.046 45.045",
    style: {
      fill: "#c5c9f7"
    }
  }));
};
export default SvgAlert;